import type { HandbookCount } from '@paction-2.0/util/constants/handbookFunnelCounts';

import { apiPublicBaseUrl } from '@/lib/env';

const HANDBOOK_EVENTS_URL = `${apiPublicBaseUrl}/handbook-events`;
const BEACON_CONTENT_TYPE = 'text/plain;charset=UTF-8';

export const sendHandbookCount = (count: HandbookCount) => {
  try {
    const body = JSON.stringify(count);
    if (
      typeof navigator !== 'undefined' &&
      typeof navigator.sendBeacon === 'function' &&
      navigator.sendBeacon(
        HANDBOOK_EVENTS_URL,
        new Blob([body], { type: BEACON_CONTENT_TYPE })
      )
    ) {
      return;
    }
    void fetch(HANDBOOK_EVENTS_URL, {
      method: 'POST',
      body,
      keepalive: true,
      headers: { 'content-type': BEACON_CONTENT_TYPE }
    }).catch(() => undefined);
  } catch (_error) {
    return;
  }
};
